import React from 'react'

export default function SummaryCard({ title, items }) {
  return (
    <div className="w-full rounded-2xl border border-border-lines p-4">
      <p className="text-xs font-semibold text-secondary tracking-wide uppercase mb-3">{title}</p>

      <div className="flex flex-col gap-3">
        {
          items.map(({ icon: Icon, label, value }) => (
            <div key={label} className="flex items-start gap-2.5">
              {Icon && <Icon size={16} className="text-secondary shrink-0 mt-0.5" />}
              <div className="min-w-0">
                <p className="text-xs text-secondary">{label}</p>
                <p className="text-sm text-dark-blue">{value}</p>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  )
}
